<template>
    <form class="selector">
        <div v-if="options.length > maximumButtons" class="form-group form-group-selectr">
            <label :for="parameter" v-html="parameters.title.value"></label>

            <select :id="parameter" class="form-control" :name="parameter" v-model="value" @change.stop="updateValues($event)">
                <option v-for="option in options" :value="option.id" v-html="option.value"></option>
            </select>
        </div>

        <div v-else v-for="option in options" class="form-group form-group-button-selector" :data-selected="option.id === value" :style="{ backgroundColor: retrieveColour(option) }">
            <div>{{ option.value }}</div>

            <button class="button" @click.stop="updateValues($event, option.id, retrieveColour(option))">
                View
            </button>
        </div>
    </form>
</template>

<script>
    import VisibleSelectorWidget from './VisibleSelectorWidget';

    export default {
        extends: VisibleSelectorWidget,
        props: {
            parameter: String,
        },
        data() {
            return {
                maximumButtons: 5
            }
        },
        created() {
            this.registerParameterListeners(this.parameters, ['title']);
        },
        methods: {
            async update(data) {
                if (data.display === 'none') {
                    return this.$el.closest('.page-widget').hidden = true;
                }

                this.options = data.items;
                this.maximumButtons = data.max_buttons;
                this.setValue();
                this.updateTabColour(this.retrieveColour(this.options[0]));
            },
            updateValues(event, id = null, colour = null) {
                if (! id) {
                    id = this.value;
                    colour = this.retrieveColour(this.options.filter(option => option.id === id)[0]);
                }

                this.updateTabColour(colour);
                this.updateValue(event, id);
            },
            updateTabColour(colour) {
                document.documentElement.style.setProperty('--tabs-selected-colour', colour);
            },
            broadcast(value) {
                this.value = value;
                const eventName = 'update' + this.parameter.replace(/^\w/, c => c.toUpperCase());
                window.events.emit(eventName, value);
            }
        }
    }
</script>
